import { render, staticRenderFns } from "./datalive2.vue?vue&type=template&id=0789c5f0&scoped=true&"
import script from "./datalive2.vue?vue&type=script&lang=js&"
export * from "./datalive2.vue?vue&type=script&lang=js&"
import style0 from "./datalive2.vue?vue&type=style&index=0&id=0789c5f0&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789c5f0",
  null
  
)

export default component.exports